import React, { useState } from "react";
import "../../css/DLT.css";
import EntityModal from "./EntityModal";
import EntityIDs from "../dlt/EntityIDs";
import SenderIDs from "../dlt/SenderIDs";
import Template from "../dlt/Template";
import SenderIDModal from "./SenderIDModal";
import TemplateModal from "./TemplateModal";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import HeaderWithBreadcrumb from "../common/HeaderWithBreadcrumb";

function CustomTabPanel({ children, active }) {
  return (
    <div className={`tab-pane fade ${active ? "show active" : ""}`}>
      {children}
    </div>
  );
}

const DLT = () => {
  const [activeTab, setActiveTab] = useState("entityIDs");
  const [showModalEntity, setShowModalEntity] = useState(false);
  const [showModalSender, setShowModalSender] = useState(false);
  const [showModalTemplate, setShowModalTemplate] = useState(false);
  const { user } = useSelector((state) => state.auth);
  console.log("user", user);

  const location = useLocation();
  const { customerCode, name } = location.state || {};

  const handleTabChange = (tabName) => {
    setActiveTab(tabName);
  };

  const openModal = () => setShowModalEntity(true);
  const closeModal = () => setShowModalEntity(false);
  const openModalSender = () => setShowModalSender(true);
  const closeModalSender = () => setShowModalSender(false);
  const openModalTemplate = () => setShowModalTemplate(true);
  const closeModalTemplate = () => setShowModalTemplate(false);

  return (
    <>
      <HeaderWithBreadcrumb title="DLT" breadcrumb="Master/ Company Master" />
      <div className="flex bg-[#f1ffff] mb-4 mt-4 w-fit px-4 py-2 rounded-[8px]">
        <div className="flex gap-6">
          {/* Company Code */}
          <div className="flex items-center gap-3">
            <label
              htmlFor="custCodeInput"
              className="whitespace-nowrap font-semibold"
            >
              Company ID:
            </label>
            <input
              type="text"
              id="custCodeInput"
              className="form-control !border-[#495057] !rounded-[5px]"
              value={customerCode || ""}
              readOnly
            />
          </div>

          {/* Company Name */}
          <div className="flex items-center gap-3">
            <label
              htmlFor="custName"
              className="whitespace-nowrap font-semibold"
            >
              Company Name:
            </label>
            <input
              type="text"
              id="custName"
              className="form-control !border-[#495057] !rounded-[5px]"
              value={name || ""}
              readOnly
            />
          </div>
        </div>
      </div>

      <div className="">
        <ul className="flex mt-2 font-semibold">
          <li>
            <button
              className={`px-4 py-2 rounded-t-[5px] text-sm transition-colors
        ${
          activeTab === "entityIDs"
            ? "bg-[#00b6ce] text-white border-b-2 border-[#145165]"
            : "bg-white text-[#495057] border-b-2 border-transparent hover:bg-gray-100"
        }`}
              onClick={() => handleTabChange("entityIDs")}
            >
              Entity ID
            </button>
          </li>
          <li>
            <button
              className={`px-4 py-2 rounded-t-[5px] text-sm transition-colors
        ${
          activeTab === "senderIDs"
            ? "bg-[#00b6ce] text-white border-b-2 border-[#145165]"
            : "bg-white text-[#495057] border-b-2 border-transparent hover:bg-gray-100"
        }`}
              onClick={() => handleTabChange("senderIDs")}
            >
              Sender ID
            </button>
          </li>
          <li>
            <button
              className={`px-4 py-2 rounded-t-[5px] text-sm transition-colors
        ${
          activeTab === "template"
            ? "bg-[#00b6ce] text-white border-b-2 border-[#145165]"
            : "bg-white text-[#495057] border-b-2 border-transparent hover:bg-gray-100"
        }`}
              onClick={() => handleTabChange("template")}
            >
              Template
            </button>
          </li>
        </ul>

        <div className="tab-content dlt-tab-content !w-full !bg-[#FFFFFF] !rounded-[14px] !rounded-tl-none">
          <CustomTabPanel active={activeTab === "entityIDs"}>
            <EntityIDs
              openModal={openModal}
              customerCode={customerCode}
              name={name}
            />
          </CustomTabPanel>
          <CustomTabPanel active={activeTab === "senderIDs"}>
            <SenderIDs
              openModal={openModalSender}
              customerCode={customerCode}
              name={name}
            />
          </CustomTabPanel>
          <CustomTabPanel active={activeTab === "template"}>
            <Template
              openModal={openModalTemplate}
              customerCode={customerCode}
              name={name}
            />
          </CustomTabPanel>
        </div>

        <EntityModal
          show={showModalEntity}
          handleClose={closeModal}
          activeTab={activeTab}
          customerCode={customerCode}
          name={name}
        />
        <SenderIDModal
          show={showModalSender}
          handleClose={closeModalSender}
          activeTab={activeTab}
          customerCode={customerCode}
          name={name}
        />
        <TemplateModal
          show={showModalTemplate}
          handleClose={closeModalTemplate}
          activeTab={activeTab}
          customerCode={customerCode}
          name={name}
        />
      </div>
    </>
  );
};

export default DLT;
